import React from "react";
import { Link } from "react-router-dom";
import "./styles.css";
import perdiste from "../../assets/icono_perdiste.png"
import ganaste from "../../assets/icono_ganaste.png"

const Render = (props, context) => {
  const clase = props.correctAnswers >= props.totalQuestions ? "ok" : "error";
  return (
    <section className={`desafios resultado pbxl ${clase}`}>
      <div className="container fullHeightCalc verticalCenterFlex">
        <h2 className="mbn avenirBK white alignCenter titleSize bgNone borderBottomNone">Trivias</h2>
        <p className="white alignCenter">{props.trivia.name}</p>
        {props.trivia.historical <= 0 && (
          <div>
            <p className="sumaste white alignCenter ptn pbl">
              Sumaste:{" "}
              <span className="">
                {props.points}
                <span className=""> Pts</span>
              </span>
            </p>
          </div>
        )}
        <img
                src={props.correctAnswers >= props.totalQuestions
                  ? ganaste
                  : perdiste}
                alt=""
                className="displayBlock myl alignCenter horizontalCenter bgNone"
              />
        <p class="sumaste white alignCenter">Respondiste {props.correctAnswers} de {props.totalQuestions}</p>
        <h3 className="mha avenirBK white alignCenter ptn">
          {props.correctAnswers >= props.totalQuestions
            ? "Felicitaciones"
            : "Volvé a intentarlo"}
        </h3>

        <Link to="/trivias" className="btn mha btnGold mbn">
          Continuar
        </Link>
      </div>
    </section>
  );
};

Render.contextTypes = {};

export default Render;



// WEBPACK FOOTER //
// ./src/pages/TriviasResultado/Render.js